<template>
  <div>
    <Header />

    <header class="hero-pattern mt-24 pb-3 px-4 md:px-8">
      <div class="container mx-auto max-w-6xl">
        <div class="text-center mb-10">
          <div class="flex justify-center mb-6">
            <div
              class="w-32 h-32 md:w-40 md:h-40 rounded-full bg-medical-green flex items-center justify-center text-white text-5xl md:text-7xl animate-float"
            >
              {{ actualite?.icon }}
            </div>
          </div>
          <h1
            class="text-3xl md:text-4xl font-heading font-bold text-medical-dark mb-4"
          >
            {{ actualite?.title }}
          </h1>
          <div
            class="mt-8 flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6"
          >
            <div
              class="flex items-center bg-white rounded-lg shadow-sm py-2 px-4"
            >
              <i
                class="fas fa-calendar-day text-medical-green text-xl mr-2"
              ></i>
              <span class="font-semibold">{{ actualite?.date }}</span>
            </div>
            <div
              class="flex items-center bg-white rounded-lg shadow-sm py-2 px-4"
            >
              <i
                class="fas fa-map-marker-alt text-medical-green text-xl mr-2"
              ></i>
              <span class="font-semibold">{{ actualite?.lieu }}</span>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="sharing_box" v-if="actualite">
      <div class="share-buttons">
        <a
          :href="`mailto:?subject=${encodeURIComponent(actualite.title)}&body=${encodeURIComponent(currentUrl)}`"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fa fa-envelope"></i
        ></a>
        <a
          :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fa fa-facebook"></i
        ></a>
        <a
          :href="`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fa fa-linkedin"></i
        ></a>
        <a
          :href="`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(currentUrl)}&description=${encodeURIComponent(actualite.title)}`"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fa fa-pinterest"></i
        ></a>
        <a
          :href="`https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(actualite.title)}&hashtags=amgoran`"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fa fa-twitter"></i
        ></a>
        <a
          :href="`https://api.whatsapp.com/send?text=${encodeURIComponent(actualite.title + ' ' + currentUrl)}`"
          target="_blank"
          rel="noopener noreferrer"
          ><i class="fa fa-whatsapp"></i
        ></a>
      </div>
    </div>
    <div v-if="actualite && actualite.component && actualite.component != ''">
      <component :is="component"></component>
    </div>
    <!-- Main Content -->
    <main
      v-else-if="actualite"
      class="container mx-auto max-w-6xl mb-14 px-2 sm:px-4 md:px-8 py-3"
    >
      <!-- Hero videos (article with only videos) -->
      <div v-if="videoOnly" class="space-y-6 mb-8">
        <div
          v-for="(vd, index) in actualite.videos"
          :key="`hero-video-${index}`"
          class="relative rounded-lg overflow-hidden aspect-video bg-black max-w-4xl mx-auto"
        >
          <iframe
            v-if="loadedVideos[index]"
            :src="ytEmbed(vd.url, true, index === 0)"
            class="absolute inset-0 w-full h-full"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <template v-else>
            <img
              :src="ytThumb(vd.url)"
              @click="loadedVideos[index] = true"
              :alt="vd.title || `Vidéo ${index + 1}`"
              class="w-full h-full object-cover cursor-pointer"
            />
            <div
              class="absolute inset-0 bg-black/20 z-10 pointer-events-none"
            ></div>
            <div
              class="absolute inset-0 flex items-center justify-center z-20 pointer-events-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="w-20 h-20 text-white opacity-95 drop-shadow-lg"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          </template>
        </div>
      </div>

      <div class="grid md:grid-cols-3 gap-8">
        <!-- Left Column -->
        <div
          :class="{
            'md:col-span-4': noMedia || videoOnly,
            'md:col-span-2': !noMedia && !videoOnly,
          }"
        >
          <div class="bg-white rounded-xl shadow-md overflow-hidden mb-8">
            <div class="p-3 sm:p-6 md:p-8">
              <p
                class="text-lg text-gray-700 leading-relaxed mb-4"
                v-html="actualite?.description"
              ></p>
            </div>
          </div>

          <!-- <div class="bg-white rounded-xl shadow-md overflow-hidden">
            <div class="p-3 sm:p-6 md:p-8">
              <h2
                class="text-2xl font-heading font-semibold text-medical-dark mb-4"
              >
                Programme de l'Événement
              </h2>
              <div class="space-y-6">
                <div class="flex">
                  <div
                    class="flex-shrink-0 w-12 h-12 bg-medical-light rounded-full flex items-center justify-center text-medical-dark font-bold mr-4"
                  >
                    09h
                  </div>
                  <div>
                    <h3 class="font-semibold text-lg">Cérémonie d'ouverture</h3>
                    <p class="text-gray-600">Allocutions et mot de bienvenue</p>
                  </div>
                </div>
                <div class="flex">
                  <div
                    class="flex-shrink-0 w-12 h-12 bg-medical-light rounded-full flex items-center justify-center text-medical-dark font-bold mr-4"
                  >
                    11h
                  </div>
                  <div>
                    <h3 class="font-semibold text-lg">
                      Table ronde : L'avenir de la médecine générale
                    </h3>
                    <p class="text-gray-600">Avec des experts internationaux</p>
                  </div>
                </div>
                <div class="flex">
                  <div
                    class="flex-shrink-0 w-12 h-12 bg-medical-light rounded-full flex items-center justify-center text-medical-dark font-bold mr-4"
                  >
                    14h
                  </div>
                  <div>
                    <h3 class="font-semibold text-lg">Ateliers pratiques</h3>
                    <p class="text-gray-600">Simulations et études de cas</p>
                  </div>
                </div>
                <div class="flex">
                  <div
                    class="flex-shrink-0 w-12 h-12 bg-medical-light rounded-full flex items-center justify-center text-medical-dark font-bold mr-4"
                  >
                    16h
                  </div>
                  <div>
                    <h3 class="font-semibold text-lg">
                      Cérémonie de remise des hommages
                    </h3>
                    <p class="text-gray-600">
                      Reconnaissance des contributions exceptionnelles
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div v-if="!noMedia && !videoOnly" class="space-y-6">
          <img
            v-for="(image, index) in actualite.images"
            :key="`image-${index}`"
            :src="getImageUrl(image.url)"
            :alt="`Image ${index + 1}`"
            @click="openImage(getImageUrl(image.url))"
            class="rounded-lg w-full cursor-zoom-in hover:opacity-90 transition-opacity"
          />

          <div
            v-for="(vd, index) in actualite.videos"
            :key="`video-${index}`"
            class="relative rounded-lg overflow-hidden aspect-video bg-black"
          >
            <iframe
              v-if="loadedVideos[index]"
              :src="ytEmbed(vd.url, true)"
              class="absolute inset-0 w-full h-full"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <template v-else>
              <img
                :src="ytThumb(vd.url)"
                @click="loadedVideos[index] = true"
                :alt="vd.title || `Vidéo ${index + 1}`"
                class="w-full h-full object-cover cursor-pointer"
              />
              <div
                class="absolute inset-0 bg-black/20 z-10 pointer-events-none"
              ></div>
              <div
                class="absolute inset-0 flex items-center justify-center z-20 pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  class="w-16 h-16 text-white opacity-95"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </template>
          </div>
        </div>
      </div>
    </main>

    <!-- Lightbox -->
    <div
      v-if="lightboxImage"
      @click="lightboxImage = null"
      class="fixed inset-0 z-[2000] bg-black bg-opacity-90 flex items-center justify-center p-4 cursor-zoom-out"
    >
      <img
        :src="lightboxImage"
        @click.stop
        class="max-w-full max-h-full object-contain"
      />
      <button
        @click.stop="lightboxImage = null"
        class="absolute top-4 right-4 text-white text-4xl leading-none hover:text-gray-300"
        aria-label="Fermer"
      >
        &times;
      </button>
    </div>

    <Footer />
  </div>
</template>

<script>
const context = require.context("./actualites", false, /\.vue$/);
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import { youtubeEmbed, youtubeThumbnail } from "../utils/youtube";
import { setMetaTags } from "../router.js";

export default {
  props: {
    idOrSlug: [String, Number],
  },
  name: "ActualiteDetails",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      actualite: null,
      loading: true,
      error: null,
      lightboxImage: null,
      loadedVideos: {},
    };
  },
  computed: {
    currentUrl() {
      const path = this.actualite.slug || this.actualite.id;
      return `${window.location.origin}/actualites/${path}`;
    },
    component() {
      if (this.actualite && this.actualite.component) {
        const filePath = `./${this.actualite.component}.vue`;
        if (context.keys().includes(filePath)) {
          return context(filePath).default;
        }
      }
      return null;
    },
    noMedia() {
      if (!this.actualite) return true;
      const imagesCount = this.actualite.images?.length || 0;
      const videosCount = this.actualite.videos?.length || 0;
      return imagesCount === 0 && videosCount === 0;
    },
    videoOnly() {
      if (!this.actualite) return false;
      const imagesCount = this.actualite.images?.length || 0;
      const videosCount = this.actualite.videos?.length || 0;
      return videosCount > 0 && imagesCount === 0;
    },
  },
  async mounted() {
    try {
      const res = await fetch(
        `${process.env.VUE_APP_HSERVER_URL}/api/actualites/${this.idOrSlug}`,
      );
      if (!res.ok) throw new Error("Actualité non trouvée");
      this.actualite = await res.json();

      // Auto-load the first video (autoplay muted) when the article is video-only
      if (
        this.actualite.videos?.length > 0 &&
        (this.actualite.images?.length || 0) === 0
      ) {
        this.loadedVideos = { ...this.loadedVideos, 0: true };
      }

      const description = this.stripHtml(
        this.actualite.sub_description || this.actualite.description,
      );
      let image = null;
      const firstImage = this.actualite.images?.[0]?.url;
      if (firstImage) {
        image = this.getImageUrl(firstImage);
        if (image && !image.startsWith("http")) {
          image = `${process.env.VUE_APP_HSERVER_URL}${image}`;
        }
      } else if (this.actualite.videos?.[0]?.url) {
        image = this.ytThumb(this.actualite.videos[0].url);
      }
      const urlPath = this.actualite.slug || this.actualite.id;
      setMetaTags({
        title: `${this.actualite.title} - AMGO`,
        description,
        url: `https://amgo.213devops.com/actualites/${urlPath}`,
        image,
      });
    } catch (err) {
      this.error = err.message;
    } finally {
      this.loading = false;
      this.$nextTick(() => {
        document.dispatchEvent(new Event("render-event"));
      });
    }
  },
  methods: {
    stripHtml(html) {
      if (!html) return "";
      const div = document.createElement("div");
      div.innerHTML = html;
      const text = div.textContent || div.innerText || "";
      return text.substring(0, 350);
    },
    getImageUrl(url) {
      if (!url) return "";

      if (url.includes("/assets/uploads/")) {
        return `${process.env.VUE_APP_HSERVER_URL}/amgo${url}`;
      }

      return url;
    },
    openImage(url) {
      this.lightboxImage = url;
    },
    ytThumb(url) {
      return youtubeThumbnail(url, "hqdefault");
    },
    ytEmbed(url, autoplay) {
      return youtubeEmbed(url, autoplay);
    },
  },
};
</script>

<style scoped>
.hero-pattern {
  background-color: #f8fafc;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23114b5f' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.animate-float {
  animation: float 6s ease-in-out infinite;
}
@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>

<style>
.sharing_box {
  z-index: 1000;
  position: fixed;
  bottom: 3%;
  left: 0%;
  background: #5f9ea08c;
  padding: 5px;
}

.share-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.share-buttons a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  font-size: 18px;
  transition: 0.3s;
}

@media (max-width: 640px) {
  .sharing_box {
    bottom: auto;
    top: 5rem;
    left: auto;
    right: 0;
    padding: 4px;
    border-radius: 0 0 0 8px;
  }
  .share-buttons {
    flex-direction: column;
    gap: 6px;
  }
  .share-buttons a {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
}

.share-buttons i {
  color: #fff;
  padding: 7px 10px;
  font-size: 15px;
  cursor: pointer;
}

.share-buttons a:hover {
  transform: scale(1.1);
}

/* Colors */
.share-buttons .fa-facebook {
  background: #3b5998 !important;
}
.share-buttons .fa-twitter {
  background: #1da1f2;
}
.share-buttons .fa-linkedin {
  background: #0077b5;
}
.share-buttons .fa-whatsapp {
  background: #25d366 !important;
}
.share-buttons .fa-telegram {
  background: #0088cc;
}
.share-buttons .fa-reddit {
  background: #ff4500;
}
.share-buttons .fa-pinterest {
  background: #bd081c;
}
.share-buttons .fa-envelope {
  background: #666;
}
</style>
